export const badgeScrollData = [
    {
        text: 'Stella Nowland',
        class: 'warning',
        badge: 'Freelance'
    },
    {
        text: 'Lola Stanford',
        class: 'danger',
        badge: 'Issue'
    },
    {
        text: 'Caitlin Coungeau',
        class: 'primary',
        badge: 'Social'
    },
    {
        text: 'Graciela W. McClaran',
        class: 'danger',
        badge: 'Issue'
    },
    {
        text: 'Derek T. Aldridge',
        class: 'warning',
        badge: 'Freelance '
    },
    {
        text: 'Annie A. Riley',
        class: 'primary',
        badge: 'Social '
    },
    {
        text: 'Hana J. Boyd',
        class: 'danger',
        badge: 'Issue'
    },
    {
        text: 'Karen R. Pryce',
        class: 'warning',
        badge: 'Freelance'
    },
    {
        text: 'Cordie C. Pope',
        class: 'primary',
        badge: 'Social'
    }
]

export const profileScrollData = [
    {
        img: 'user/3.png',
        text: 'Gloria D. Acheson'
    },
    {
        img: 'user/2.jpg',
        text: 'Sharon C. Obrien'
    },
    {
        img: 'user/5.jpg',
        text: 'Bryan A. Owens'
    },
    {
        img: 'user/12.png',
        text: 'Ronald M. Enger'
    },
    {
        img: 'user/14.png',
        text: 'Herbert A. Clary'
    },
    {
        img: 'user/6.jpg',
        text: 'Dino A. Cannon'
    },
    {
        img: 'user/3.jpg',
        text: 'Danny A. McLean'
    },
    {
        img: 'user/2.jpg',
        text: 'Betty K. Curtis'
    }
]

export const scrollableContentData = [
    {
        img: 'user/9.jpg',
        head: 'Molly Boake',
        mail: 'MollyBoake@rhyta.com',
        small: '5 days ago'
    },
    {
        img: 'user/10.jpg',
        head: 'Gabrielle Fahey',
        mail: 'GabrielleFahey@dayrep.com',
        small: '10 days ago'
    },
    {
        img: 'user/2.jpg',
        head: 'Lucinda Moseley',
        mail: 'LucindaMoseley@teleworm.us',
        small: '3 days ago'
    },
    {
        img: 'user/12.png',
        head: 'Francis K. Henriques',
        mail: 'FrancisKHenriques@teleworm.us',
        small: '2 days ago'
    },
    {
        img: 'user/14.png',
        head: 'Jose A. Seay',
        mail: 'JoseASeay@rhyta.com',
        small: '15 days ago'
    },
    {
        img: 'user/3.jpg',
        head: 'Phil F. Cunningham',
        mail: 'PhilFCunningham@dayrep.com',
        small: '6 days ago'
    },
    {
        img: 'user/7.jpg',
        head: 'Richard E. Johnson',
        mail: 'RichardEJohnson@teleworm.us',
        small: '20 days ago'
    },
    {
        img: 'user/2.png',
        head: 'Lawrence L. Nash',
        mail: 'LawrenceLNash@jourrapide.com',
        small: '8 days ago'
    }
]

export const horizontalData = [
     'fashion1.jpg', 'fashion2.jpg',
     'fashion3.jpg',
     'fashion4.jpg',
     'fashion5.jpg',
     'fashion6.jpg',
]